import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import styled from "styled-components";
import { projects } from "../../pages/data";



const SliderContainer = styled.div`
  .slick-slide {
    padding: 0 10px;
  }
  .slick-prev,
  .slick-next {
    z-index: 1;
  }
`;

const ProjectCard = styled.div`
  text-align: center;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
`;

const ProjectImage = styled.div`
  img {
    width: 100%;
    height: auto;
    border-bottom: 2px solid #ddd;
  }
`;

const ProjectText = styled.div`
  padding: 20px;
  h4 {
    font-size: 18px;
    margin: 10px 0;
  }
  p {
    font-size: 16px;
    color: #777;
  }
  span {
    display: block;
    margin-top: 10px;
    font-size: 14px;
    color: #444;
  }
`;

const OurProjects = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <section className="bleezy-service-area bleezy-promo-area section_t_100 section_b_70">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="heading_container" style={{ marginBottom: "30px" }}>
              <h2 className="section-title">
                Our Projects <br />
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <SliderContainer>
          <Slider {...settings}>
            {projects.map((project) => (
              <ProjectCard key={project.id}>
                <ProjectImage>
                  <img src={project.image} alt={project.name} />
                </ProjectImage>
                <ProjectText>
                  <h4>{project.name}</h4>
                  <p>{project.location}</p>
                  <span>{project.description}</span>
                </ProjectText>
              </ProjectCard>
            ))}
          </Slider>
        </SliderContainer>
      </div>
    </section>
  );
};

export default OurProjects;
